import React from "react";

// Import interfaces
import { GridDividerItemProps } from "../helpers/interfaces";
// Import hooks
import { useGridExternalDnD } from "../hooks/useGridExternalDnD";
// Import styles
import { GridStyled } from "../styles";

const { GridDivider } = GridStyled;

export function GridDividerItem({
  index,
  item,
  dividerProps,
}: GridDividerItemProps) {
  const { styles, props } = dividerProps;
  const { onItemClick, onItemDrop, ...restProps } = props;
  const { isDragOver, onDrop, onDragEnter, onDragLeave, dropAreaRef } =
    useGridExternalDnD({
      onItemDrop,
    });
  return (
    <GridDivider
      className="planby-grid-item-divider"
      ref={dropAreaRef}
      key={index}
      {...styles}
      left={styles.left(index)}
      {...restProps}
      onClick={onItemClick(item, index)}
      // Drag
      isDragOver={isDragOver}
      onDragEnter={onDragEnter}
      onDragLeave={onDragLeave}
      onDrop={onDrop(item, index)}
    />
  );
}
